import React from 'react';
import AreaSourceBudgetCentralePerArea from 'src/mtska-frontend-modules/modules/AreaSource/components/dashboard/budgetCentralePerArea/BudgetCentralePerArea';
import AreaSourceBudgetLocalePerArea from 'src/mtska-frontend-modules/modules/AreaSource/components/dashboard/budgetLocalePerArea/BudgetLocalePerArea';
import SourceBudgetCentralePerArea from 'src/mtska-frontend-modules/modules/Source/components/dashboard/budgetCentralePerArea/BudgetCentralePerArea';
import SourceBudgetLocalePerArea from 'src/mtska-frontend-modules/modules/Source/components/dashboard/budgetLocalePerArea/BudgetLocalePerArea';
import ListingAnalisiListing from 'src/mtska-frontend-modules/modules/Listing/components/dashboard/analisiListing/AnalisiListing';
import ProposalProposteAnalisi from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/proposteAnalisi/ProposteAnalisi';
import ProposalProposteAreaShop from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/proposteAreaShop/ProposteAreaShop';
import ProposalProposteSourceAreaShop from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/proposteSourceAreaShop/ProposteSourceAreaShop';
import ProposalAccettateAnalisi from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/accettateAnalisi/AccettateAnalisi';
import ProposalAccettateAreaShop from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/accettateAreaShop/AccettateAreaShop';
import ProposalAccettateSourceAreaShop from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/accettateSourceAreaShop/AccettateSourceAreaShop';
import ProposalMaturatoAnalisi from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/maturatoAnalisi/MaturatoAnalisi';
import ProposalMaturatoTimeline from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/maturatoTimeline/MaturatoTimeline';
import ProposalMaturatoAreaShop from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/maturatoAreaShop/MaturatoAreaShop';
import ProposalMaturatoSourceAreaShop from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/maturatoSourceAreaShop/MaturatoSourceAreaShop';
import ProposalMaturatoBuyerAgent from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/maturatoBuyerAgent/MaturatoBuyerAgent';
import ProposalMaturatoSellerAgent from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/maturatoSellerAgent/MaturatoSellerAgent';
import ProposalProposteRanking from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/proposteRanking/ProposteRanking';
import ProposalProposteTimeline from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/proposteTimeline/ProposteTimeline';
import ProposalAccettateRanking from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/accettateRanking/AccettateRanking';
import ProposalAccettateTimeline from 'src/mtska-frontend-modules/modules/Proposal/components/dashboard/accettateTimeline/AccettateTimeline';
import AdvertisingCostiTimeline from 'src/mtska-frontend-modules/modules/AdvertisingCost/components/dashboard/costiTimeline/CostiTimeline';
import AdvertisingCostiRanking from 'src/mtska-frontend-modules/modules/AdvertisingCost/components/dashboard/costiRanking/CostiRanking';
import AdvertisingCostiAnalisi from 'src/mtska-frontend-modules/modules/AdvertisingCost/components/dashboard/costiAnalisi/CostiAnalisi';
import LeadIndicatoriDiSintesi from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/indicatoriDiSintesi/IndicatoriDiSintesi';
import LeadAnalisi from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/leadAnalisi/LeadAnalisi';
import LeadTimeline from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/leadTimeline/LeadTimeline';
import LeadRanking from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/leadRanking/LeadRanking';
import LeadAreaShop from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/leadAreaShop/LeadAreaShop';
import LeadSourceAreaShop from 'src/mtska-frontend-modules/modules/Lead/components/dashboard/leadSourceAreaShop/LeadSourceAreaShop';

export const DATA_PROVIDER_AREA_SOURCE = 'commercials/areaSource';
export const DATA_PROVIDER_SOURCE = 'advertisings/source';
export const DATA_PROVIDER_LISTING = 'opportunities/listing';
export const DATA_PROVIDER_PROPOSAL = 'opportunities/proposal';
export const DATA_PROVIDER_ADVERTISING_COST = 'advertisings/advertisingcost';
export const DATA_PROVIDER_LEAD = 'opportunities/lead';

/**
 * @param {string} [keyPrefix] Prefisso chiavi React (es. biIntegrated); se assente si usano chiavi stabili brevi.
 */
const k = (keyPrefix, id) => (keyPrefix ? `${keyPrefix}-${id}` : id);

/**
 * @param {(key: string) => string} t i18n `t`
 * @param {string} dataProviderName
 * @param {*} filters filterModel o defaultFilters
 */
export function buildDashboardReportAreaSourceBudget(t, dataProviderName, filters, keyPrefix) {
    return [
        {
            title: t('Budget'),
            icon: 'faMoneyBillTransfer',
            pages: [
                {
                    title: t('Centrale per Area'),
                    icon: 'faGlobe',
                    component: <AreaSourceBudgetCentralePerArea dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'as-centrale')} />
                },
                {
                    title: t('Locale per Area'),
                    icon: 'faShop',
                    component: <AreaSourceBudgetLocalePerArea dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'as-locale')} />
                }
            ]
        }
    ];
}

export function buildDashboardReportSourceBudget(t, dataProviderName, filters, keyPrefix) {
    return [
        {
            title: t('Budget'),
            icon: 'faMoneyBillTransfer',
            pages: [
                {
                    title: t('Centrale per Area'),
                    icon: 'faGlobe',
                    component: <SourceBudgetCentralePerArea dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'src-centrale')} />
                },
                {
                    title: t('Locale per Area'),
                    icon: 'faShop',
                    component: <SourceBudgetLocalePerArea dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'src-locale')} />
                }
            ]
        }
    ];
}

export function buildDashboardReportListing(t, dataProviderName, filters, keyPrefix) {
    return [
        {
            title: t('Listing'),
            icon: 'faRectangleHistoryCircleUser',
            pages: [
                {
                    title: t('Analisi'),
                    icon: 'faChartPie',
                    component: <ListingAnalisiListing dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'listing-analisi')} />
                }
            ]
        }
    ];
}

export function buildDashboardReportProposal(t, dataProviderName, filters, keyPrefix) {
    const pie = 'faChartPie';
    const pivot = 'faTablePivot';

    return [
        {
            title: t('Proposte'),
            icon: 'faHandshake',
            pages: [
                {
                    title: t('Analisi'),
                    icon: pie,
                    component: <ProposalProposteAnalisi dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'prop-analisi-proposte')} />
                },
                {
                    title: t('Andamento'),
                    icon: 'faCalendar',
                    component: <ProposalProposteTimeline dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'prop-time')} />
                },
                {
                    title: t('Classifiche'),
                    icon: 'faRankingStar',
                    component: <ProposalProposteRanking dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'prop-rank')} />
                },
                {
                    title: t('Area e Shop'),
                    icon: pivot,
                    component: <ProposalProposteAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'prop-area-shop')} />
                },
                {
                    title: t('Source e Area'),
                    icon: pivot,
                    component: <ProposalProposteSourceAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'prop-source-area')} />
                }
            ]
        },
        {
            title: t('Accettate'),
            icon: 'faThumbsUp',
            pages: [
                {
                    title: t('Analisi'),
                    icon: pie,
                    component: <ProposalAccettateAnalisi dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'acc-analisi')} />
                },
                {
                    title: t('Andamento'),
                    icon: 'faCalendar',
                    component: <ProposalAccettateTimeline dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'acc-time')} />
                },
                {
                    title: t('Classifiche'),
                    icon: 'faRankingStar',
                    component: <ProposalAccettateRanking dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'acc-rank')} />
                },
                {
                    title: t('Area e Shop'),
                    icon: pivot,
                    component: <ProposalAccettateAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'acc-area-shop')} />
                },
                {
                    title: t('Source e Area'),
                    icon: pivot,
                    component: <ProposalAccettateSourceAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'acc-source-area')} />
                }
            ]
        },
        {
            title: t('Maturato'),
            icon: 'faMoneyBill',
            pages: [
                {
                    title: t('Analisi'),
                    icon: pie,
                    component: <ProposalMaturatoAnalisi dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'mat-analisi')} />
                },
                {
                    title: t('Andamento'),
                    icon: 'faCalendar',
                    component: <ProposalMaturatoTimeline dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'mat-time')} />
                },
                {
                    title: t('Area e Shop'),
                    icon: pivot,
                    component: <ProposalMaturatoAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'mat-area-shop')} />
                },
                {
                    title: t('Source e Area'),
                    icon: pivot,
                    component: <ProposalMaturatoSourceAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'mat-source-area')} />
                },
                {
                    title: t('Buyer agent'),
                    icon: pivot,
                    component: <ProposalMaturatoBuyerAgent dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'mat-buyer')} />
                },
                {
                    title: t('Seller agent'),
                    icon: pivot,
                    component: <ProposalMaturatoSellerAgent dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'mat-seller')} />
                }
            ]
        }
    ];
}

export function buildDashboardReportAdvertisingCost(t, dataProviderName, filters, keyPrefix) {
    return [
        {
            title: t('Costs'),
            icon: 'faCommentDollar',
            pages: [
                {
                    title: t('Analisi'),
                    icon: 'faChartPie',
                    component: <AdvertisingCostiAnalisi dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'adv-analisi')} />
                },
                {
                    title: t('Andamento'),
                    icon: 'faCalendar',
                    component: <AdvertisingCostiTimeline dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'adv-time')} />
                },
                {
                    title: t('Classifiche'),
                    icon: 'faRankingStar',
                    component: <AdvertisingCostiRanking dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'adv-rank')} />
                }
            ]
        }
    ];
}

function getLeadDashboardPages(t, dataProviderName, filters, keyPrefix) {
    return [
        {
            title: t('Indicatori di Sintesi'),
            icon: 'faCup',
            component: <LeadIndicatoriDiSintesi dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'lead-ind')} />
        },
        {
            title: t('Analisi'),
            icon: 'faChartPie',
            component: <LeadAnalisi dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'lead-analisi')} />
        },
        {
            title: t('Andamento'),
            icon: 'faCalendar',
            component: <LeadTimeline dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'lead-time')} />
        },
        {
            title: t('Classifiche'),
            icon: 'faRankingStar',
            component: <LeadRanking dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'lead-rank')} />
        },
        {
            title: t('Area e Shop'),
            icon: 'faTablePivot',
            component: <LeadAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'lead-area-shop')} />
        },
        {
            title: t('Source e Area'),
            icon: 'faTablePivot',
            component: <LeadSourceAreaShop dataProviderName={dataProviderName} filters={filters} key={k(keyPrefix, 'lead-source-area-shop')} />
        }
    ];
}

/**
 * @param {object} [options]
 * @param {'module' | 'biIntegrated'} [options.structure='module']
 * @param {string} [options.keyPrefix]
 */
export function buildDashboardReportLead(t, dataProviderName, filters, options = {}) {
    const { structure = 'module', keyPrefix } = options;
    const pages = getLeadDashboardPages(t, dataProviderName, filters, keyPrefix);

    if (structure === 'biIntegrated') {
        const [indicatoriPage, ...restPages] = pages;
        return [
            {
                title: t('Executive Summary'),
                icon: 'faCircleCheck',
                pages: [
                    {
                        ...indicatoriPage,
                        icon: 'faCircleCheck',
                    }
                ]
            },
            {
                title: t('Lead'),
                icon: 'faChartPyramid',
                pages: restPages
            }
        ];
    }

    return [
        {
            title: t('Lead'),
            icon: 'faChartPyramid',
            pages
        }
    ];
}
